import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const PropertyService = {

  createProperty: async (propertyData) => {
    try {
      const response = await axios.post(`${API_URL}/Property/CreateProperty/`, propertyData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPropertyById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/Property/GetPropertyById/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

    getPropertiesByClientId: async (clientId) => {
        try {
          const response = await axios.get(`${API_URL}/Property/GetPropertiesByClientId/${clientId}`);
          return response.data.$values;
        } catch (error) {
          console.error(`Error fetching properties with clientId ${clientId}: `, error);
          throw error;
        }
      }, 

      updateProperty: async (id, propertyData) => {
        try {
          const response = await axios.put(`${API_URL}/Property/UpdateProperty/${id}`, propertyData);
          return response.data;
        } catch (error) {
          throw error;
        }
      },

      deleteProperty: async (id) => {
        try {
          await axios.delete(`${API_URL}/Property/DeleteProperty/${id}`);
        } catch (error) {
          throw error;
        }
      },

};
export default PropertyService;